import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminAPIs } from '@totem/components/ui_components/menus/mainMenu/admin_apis';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ApiManagementPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard>
        <TabContentMenu items={getMenuAdminAPIs(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default ApiManagementPage;
